var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"id":"home"}},[_c('HelloWorld',{attrs:{"msg":"Elastic.Ventures"}}),_c('AboutEV')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }